import React, { useState, useEffect } from 'react';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfoV2 } from 'backend/categories';
import FormSelect from 'components/Select/FormSelect';
import style from './ModificationsDishCategorySelect.module.scss';

interface IProps {
	setModificationsDishCategory: (value: Nullable<string>) => void;
	IDsSelectedRestaurant: string[];
}

export const ModificationsDishCategorySelect: React.FC<IProps> = React.memo(
	({ setModificationsDishCategory, IDsSelectedRestaurant }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);
		const { response, loading, refetch, responseError } = useFetchData<
			IGetCategoriesShortResponse,
			IGetCategoriesShort
		>(IDsSelectedRestaurant.length ? getCategoriesShortInfoV2 : null, { restaurantIds: IDsSelectedRestaurant });

		useEffect(() => {
			if (isFirstRender) {
				setIsFirstRender(false);
			} else {
				refetch();
			}
		}, [IDsSelectedRestaurant]);

		return (
			<FormSelect
				name="selectedModificationsDishCategory"
				label="categoryLabel"
				formItemClassName={style.container}
				options={response?.data.categories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!IDsSelectedRestaurant.length || loading}
				onChange={setModificationsDishCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
